export const WORKFLOW_EDITOR_ADAPTER_CONSTANTS = {
  NODE_PALETTE_COLUMNS: 4,
  NODE_PALETTE_X_SPACING: 280,
  NODE_PALETTE_Y_SPACING: 180,
  NODE_PALETTE_OFFSET: 100,
};
